'use strict';

import Header from './components/header';
import Toggle from './partials/toogle';
import Accordion from './components/accordion';
import Summary from './partials/summary';

new Header();
new Toggle();
new Accordion();
new Summary();

const componentMapping = {
    hero_home: () => import('./components/hero_home'),
    categorias_busca: () => import('./components/categorias_busca'),
    webstories: () => import('./components/webstories'),
    organizacoes: () => import('./components/organizacoes'),
    formulario_de_contato: () => import('./components/formulario_de_contato'),
};

(async function initializeComponents() {
    for (const [dataComponent, importComponent] of Object.entries(componentMapping)) {
        if (document.querySelector(`[data-component="${dataComponent}"]`)) {
            try {
                const { default: ComponentClass } = await importComponent();
                document.querySelectorAll(`[data-component="${dataComponent}"]`).forEach((componentElement) => {
                    new ComponentClass(componentElement);
                });
            } catch (error) {
                console.error(`Error loading component ${dataComponent}:`, error);
            }
        }
    }
})();

export function loadRecaptcha() {
    const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
    document.head.appendChild(script);
}

window.reloadCaptcha = function reloadCaptcha(action, fieldName = 'g-recaptcha-response', fn = null) {
    grecaptcha.ready(function () {
        const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');

        grecaptcha
            .execute(siteKey, {
                action: action,
            })
            .then(function (token) {
                const inputElement = document.querySelector("input[name='" + fieldName + "']");
                if (inputElement) {
                    inputElement.value = token;
                }

                if (fn) {
                    fn();
                }
            });
    });
};
